module.exports = __webpack_public_path__ + "img/product-program-switch-ykp.218f74a9.png";